import React from 'react';
import FontIcon from 'material-ui/FontIcon';

const CarDetails = ({ car = {} }) =>
  car.plate ? (
    <div>
      <p>
        <FontIcon className="fa fa-car" style={{ fontSize: 16 }} /> {car.make} {car.model} <strong>{car.plate}</strong>{' '}
        | Parking #{car.parking_spot}
      </p>
      {car.code ? (
        <p>
          <FontIcon className="fa fa-lock" style={{ fontSize: 16 }} /> Code: {car.code}
        </p>
      ) : null}
    </div>
  ) : null;

export default CarDetails;



// WEBPACK FOOTER //
// ./src/components/Dashboard/CarDetails.js